var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPath293(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.738,
    height: 17.739,
    viewBox: "-21942.455 7166.878 17.738 17.739",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m-21933.586 7168 8.87 7.747-8.87 7.748-8.87-7.748 8.87-7.748Z",
    fill: "#fff",
    fillRule: "evenodd",
    "data-name": "Path 293"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPath293);
export default __webpack_public_path__ + "static/media/Path 293.90c06f77f511547e36c0a561be313abf.svg";
export { ForwardRef as ReactComponent };